'use client'

import { SolanaAdapter } from '@reown/appkit-adapter-solana'
import { createAppKit } from '@reown/appkit/react'
import { solana } from '@reown/appkit/networks'
import React, { ReactNode } from 'react'

const solanaAdapter = new SolanaAdapter({ wallets: [] })
const appUrl = typeof window !== 'undefined' ? window.location.origin : 'https://app.godefi.me'

createAppKit({
  adapters: [solanaAdapter],
  networks: [solana],
  projectId: process.env.NEXT_PUBLIC_WC_PROJECT_ID,
  metadata: {
    name: 'GoDefi',
    description: 'GoDefi',
    url: appUrl,
    icons: [`${appUrl}/favicon.ico`],
  },
  features: {
    email: false,
    socials: [],
    analytics: false,
    swaps: false,
    onramp: false,
  },
})

export function WalletConnectProvider({ children }: { children: ReactNode }) {
  return <>{children}</>
}
